import { Base, Component, ModelSync, Prop } from '@/vue-property-decorator'
import { ExtractClassProps } from '@/plugins/ant-design-vue/type'
import { Input } from '@/plugins/ant-design-vue/tsx-support'
import { SvgSprite } from '@/components/icon-sprite'
import { Input as _Input } from 'ant-design-vue'
import { ofType } from '@/vue-tsx-support/src'
import { useMainStore } from '@/store/index'
import AppTypes from '@/vue-types'
import style from './style.module.scss'
type Props = {
  preIcon: SvgSprite
  isRequire: boolean
}
@Component<RealNameInput>({ name: 'RealNameInput' })
class RealNameInput extends Base {
  @ModelSync('value', 'input', AppTypes.string.isRequired.def(''))
  protected realName!: NonNullable<string>

  /**
   * 真实姓名是否必须大写
   */
  get isValidateRealNameUppercase() {
    return useMainStore().isValidateRealNameUppercase
  }
  @Prop()
  private preIcon?: Props['preIcon']
  @Prop()
  private isRequire?: Props['isRequire']
  /**
   * 处理真实姓名
   */
  lockABC(event: InputEvent) {
    const target = event.target as HTMLInputElement

    // 处理禁止输入多个空格
    const deleteBlock = (str: string) => str.replace(/\s(\s+)/, (m) => m[0])
    if (this.isValidateRealNameUppercase) {
      const _temp = target.value.replace(/[^a-zA-Z'‘’.·,\s]/g, '')
      this.realName = deleteBlock(_temp).toUpperCase()
    } else {
      const reg = new RegExp(
        '[`0-9《》\\%\\+\\-\\_!$\\^()=:;\\[\\]<>/~！@#￥…&*?（）—|{}【】"“”；：。，、？]',
        'g'
      )
      const _temp = target.value.replace(reg, '')
      this.realName = deleteBlock(_temp)
    }
    this.$emit('change')
  }

  /**
   * 去除空格
   */
  trimSpace() {
    this.realName = this.realName.trim()
    this.$emit('blur')
  }
  /**
   * render icon
   */
  renderPreIcon() {
    return (
      <Input.Tsx
        v-model={this.realName}
        onBlur={this.trimSpace}
        onChange={this.lockABC}
        prefix={() => {
          return (
            <div class={style.inputRequire}>
              <icon-sprite sprite={this.preIcon!}></icon-sprite>
              {this.isRequire && <span class={style.require}>*</span>}
            </div>
          )
        }}
        {...{
          props: {
            ...this.$attrs
          },
          directives: [
            {
              name: 'disable-copy-parse',
              value: this.isValidateRealNameUppercase
            }
          ]
        }}
      ></Input.Tsx>
    )
  }
  renderNomoalInput() {
    return (
      <Input.Tsx
        v-model={this.realName}
        onBlur={this.trimSpace}
        onChange={this.lockABC}
        {...{
          props: {
            ...this.$attrs
          },
          directives: [
            {
              name: 'disable-copy-parse',
              value: this.isValidateRealNameUppercase
            }
          ]
        }}
      />
    )
  }
  render() {
    return this.preIcon ? this.renderPreIcon() : this.renderNomoalInput()
  }
}

export default ofType<ExtractClassProps<_Input>>().convert(RealNameInput)
